import Const from 'const';

class SwappedPlayers {
    constructor(
        private swappedPlayersQuantity: number = 0,
        private lastUpdatedLineupId: number | null = null,
    ) {}
    getSwappedPlayersQuantity(): number {
        return this.swappedPlayersQuantity;
    }
    isSwappedPlayersQuantityEqual(swappedPlayers: SwappedPlayers): boolean {
        return this.swappedPlayersQuantity === swappedPlayers.getSwappedPlayersQuantity();
    }
    getLastUpdatedLineupId(): number | null {
        return this.lastUpdatedLineupId;
    }
}

const swappedPlayers = new SwappedPlayers();

export default function (state = swappedPlayers, action) {
    if (action.type === Const.SWAPPED_PLAYERS_SET_LAST_UPDATED_LINEUP_ID) {
        const swappedPlayersQuantity = 1 + state.getSwappedPlayersQuantity();

        state = new SwappedPlayers(swappedPlayersQuantity, action.value);
    } else if (inArray(action.type, [Const.FILTER_BY_SLATE, Const.OPTIMIZATION_START])) {
        state = new SwappedPlayers();
    }

    return state;
}
